import React from 'react';
import SavedReportListItem from './SavedReportListItem';
import ReportListItem from './ReportListItem';


export default (props) => props.baseReport ? 
  <SavedReportListItem {...props}/> :
  <ReportListItem {...props}/>